import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Layout
import AppLayout from './components/layout/AppLayout';

// Auth pages
import Login from './pages/auth/Login';
import { ForgotPassword, ResetPassword } from './pages/auth/ForgotPassword';

// App pages
import Dashboard from './pages/dashboard/Dashboard';
import Products from './pages/products/Products';
import RawMaterials from './pages/rawMaterials/RawMaterials';
import BOM from './pages/bom/BOM';
import Vendors from './pages/vendors/Vendors';
import SalesOrders from './pages/salesOrders/SalesOrdersV2';
import HazMatShipping from './pages/salesOrders/HazMatShipping';
import B2BOrders from './pages/b2b/B2BOrders';
import B2BEmails from './pages/b2b/B2BEmails';
import Invoices from './pages/b2b/Invoices';
import AccountStatement from './pages/b2b/AccountStatement';
import Backorders from './pages/backorders/Backorders';
import RMA from './pages/rma/RMA';
import WorkOrders from './pages/workOrders/WorkOrders';
import PurchaseOrders from './pages/purchaseOrders/PurchaseOrders';
import Receiving from './pages/receiving/Receiving';
import Kits from './pages/kits/Kits';
import Adjustments from './pages/adjustments/Adjustments';
import Forecast from './pages/forecast/Forecast';
import Alerts from './pages/alerts/Alerts';
import Integrations from './pages/integrations/Integrations';
import AIPanel from './pages/ai/AI';
import Settings from './pages/settings/Settings';
import BoxSizes from './pages/settings/BoxSizes';
import HazMatFormEditor from './pages/settings/HazMatFormEditor';
import Profile from './pages/settings/Profile';
import Users from './pages/users/Users';

// Reports (named exports)
import {
  InventoryValuation,
  GrossMargin,
  Shrinkage,
  ReorderCost,
  WeeklyReport,
  UpcomingDeliveries,
} from './pages/reports/Reports';
import { InventoryOnHand } from './pages/reports/Reports';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public auth routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Protected app routes */}
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Inventory */}
            <Route path="/products" element={<Products />} />
            <Route path="/raw-materials" element={<RawMaterials />} />
            <Route path="/bom" element={<BOM />} />

            {/* Sales */}
            <Route path="/sales-orders" element={<SalesOrders />} />
            <Route path="/hazmat-shipping" element={<HazMatShipping />} />
            <Route path="/b2b-orders" element={<B2BOrders />} />
            <Route path="/b2b-emails" element={<B2BEmails />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/account-statement" element={<AccountStatement />} />
            <Route path="/backorders" element={<Backorders />} />
            <Route path="/rma" element={<RMA />} />

            {/* Production */}
            <Route path="/work-orders" element={<WorkOrders />} />
            <Route path="/kits" element={<Kits />} />
            <Route path="/adjustments" element={<Adjustments />} />

            {/* Procurement */}
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/purchase-orders" element={<PurchaseOrders />} />
            <Route path="/receiving" element={<Receiving />} />

            {/* Planning */}
            <Route path="/forecast" element={<Forecast />} />
            <Route path="/alerts" element={<Alerts />} />

            {/* Reports */}
            <Route path="/reports/valuation" element={<InventoryValuation />} />
            <Route path="/reports/inventory" element={<InventoryOnHand />} />
            <Route path="/reports/margin" element={<GrossMargin />} />
            <Route path="/reports/shrinkage" element={<Shrinkage />} />
            <Route path="/reports/reorder" element={<ReorderCost />} />
            <Route path="/reports/weekly" element={<WeeklyReport />} />
            <Route path="/reports/upcoming-deliveries" element={<UpcomingDeliveries />} />

            {/* System */}
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/ai" element={<AIPanel />} />
            <Route path="/users" element={<Users />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/profile" element={<Profile />} />
            <Route path="/settings/hazmat-form" element={<HazMatFormEditor />} />
            <Route path="/box-sizes" element={<BoxSizes />} />

            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
